import src from "IMAGE";
export default { src, width: 35, height: 35 }
